import React from 'react';
import { Link } from 'react-router-dom';
import {
  ChartBarIcon,
  BuildingOffice2Icon,
  UserIcon,
  ClipboardDocumentCheckIcon,
  Bars3Icon,
} from '@heroicons/react/24/outline';
import { useEffectiveRole } from '../hooks/useEffectiveRole';
import { View, VIEW_TO_PATH } from '../routes';

interface MobileTabBarProps {
  currentView: View;
  setCurrentView: (view: View) => void;
  onMoreClick: () => void;
}

const MobileTabBar: React.FC<MobileTabBarProps> = ({ currentView, setCurrentView, onMoreClick }) => {
  const role = useEffectiveRole();
  const showEval = ['admin', 'hr_manager', 'org_head'].includes(role);
  const showDashboard = ['admin', 'hr_manager'].includes(role);

  const tabs: { key: View | 'more'; label: string; icon: React.ReactNode }[] = [];
  if (showDashboard) {
    tabs.push({ key: 'dashboard', label: '대시보드', icon: <ChartBarIcon /> });
  }
  tabs.push(
    { key: 'org_mgmt', label: '조직관리', icon: <BuildingOffice2Icon /> },
    { key: 'mypage', label: '마이페이지', icon: <UserIcon /> },
  );

  if (showEval) {
    tabs.push({ key: 'eval_mgmt', label: '평가관리', icon: <ClipboardDocumentCheckIcon /> });
  }

  tabs.push({ key: 'more', label: '더보기', icon: <Bars3Icon /> });

  return (
    <nav className="mobile-tab-bar" aria-label="하단 탭 메뉴">
      {tabs.map((tab) => (
        tab.key === 'more' ? (
          <button
            key={tab.key}
            className="mobile-tab-item"
            onClick={onMoreClick}
            aria-label={tab.label}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </button>
        ) : (
          <Link
            key={tab.key}
            to={VIEW_TO_PATH[tab.key as View]}
            className={`mobile-tab-item${currentView === tab.key ? ' active' : ''}`}
            onClick={() => setCurrentView(tab.key as View)}
            aria-current={currentView === tab.key ? 'page' : undefined}
            aria-label={tab.label}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </Link>
        )
      ))}
    </nav>
  );
};

export default MobileTabBar;
